import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            探索品种知识
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            按主题分类浏览，系统学习大鸡巴品种的各个方面，从入门到精通
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.slice(0, 3).map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 group cursor-pointer"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  title={`${cat.name} - 大鸡巴品种科普`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className="absolute bottom-3 left-4 flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-white/20 backdrop-blur-sm">
                    <i className={`${cat.icon} text-white text-lg`}></i>
                  </div>
                  <span className="text-white font-semibold font-heading text-base">
                    {cat.name}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
                <div className="mt-3 flex items-center gap-1 text-xs font-medium text-primary-600">
                  <span>浏览文章</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {categories.length > 3 && (
          <div className="hidden lg:grid grid-cols-2 gap-5 md:gap-6 mt-6">
            {categories.slice(3).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 group cursor-pointer flex"
              >
                <div className="relative w-40 h-32 flex-shrink-0 overflow-hidden">
                  <img
                    src={cat.imageUrl}
                    alt={cat.name}
                    title={`${cat.name} - 大鸡巴品种科普`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 flex flex-col justify-center">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-100">
                      <i className={`${cat.icon} text-accent-600 text-sm`}></i>
                    </div>
                    <span className="font-semibold font-heading text-foreground-950 text-sm">
                      {cat.name}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                    {cat.description}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        )}

        {categories.length > 3 && (
          <div className="lg:hidden grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-6">
            {categories.slice(3).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 group cursor-pointer"
              >
                <div className="relative w-full h-36 overflow-hidden">
                  <img
                    src={cat.imageUrl}
                    alt={cat.name}
                    title={`${cat.name} - 大鸡巴品种科普`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-100">
                      <i className={`${cat.icon} text-accent-600 text-sm`}></i>
                    </div>
                    <span className="font-semibold font-heading text-foreground-950 text-sm">
                      {cat.name}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">
                    {cat.description}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}